export default __webpack_public_path__ + "static/media/activeM1.f7aec339.svg";